<template>
  <div class="d-flex error-page justify-center">
    <div class="error-page__banner">
      <div class="error-code text-center">
        <h1 class="error-code__title">403</h1>
        <h2>No es posible acceder a esta sección</h2>
        <v-btn color="secondary"
               class="mt-2 elevation-0 white--text text-none"
               @click="goToLogin">
          Ir al inicio
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goToLogin () {
      this.$router.push({ name: 'login' })
    }
  }
}
</script>
